import { useState, useEffect } from 'react';
import { DolaThemes } from '../styles/types';

// Define available themes
export const colorSchemes: Record<string, string> = {
  DARK: '(prefers-color-scheme: dark)',
  LIGHT: '(prefers-color-scheme: light)',
};

const useDetectTheme = (callback?: () => void) => {
  const [scheme, setScheme] = useState<DolaThemes | null>(null);

  useEffect(() => {
    if (callback) {
      callback();
    }

    if (!window.matchMedia) {
      return;
    }

    // The listener
    const listener = (e: any) => {
      if (!e || !e.matches) {
        return;
      }
      const schemeNames = Object.keys(colorSchemes);

      const schemeName = schemeNames.find(
        (schemeName) => e.media === colorSchemes[schemeName]
      );

      if (schemeName) {
        setScheme(schemeName.toLowerCase() as DolaThemes);
      }
    };

    // Add listener for all themes
    let activeMatches = Object.keys(colorSchemes).map((schemeName) => {
      const mq = window.matchMedia(colorSchemes[schemeName]);
      mq.addListener(listener);
      listener(mq);
      return mq;
    });

    // Remove listeners, no memory leaks
    return () => {
      activeMatches.forEach((mq) => mq.removeListener(listener));
      activeMatches = [];
    };
  }, []);

  return scheme;
};

export default useDetectTheme;
